import React, { useState } from "react";
import { View, Text, StyleSheet, Image, Button, Modal, TouchableOpacity } from "react-native";
import QRCode from "react-native-qrcode-svg";

const WebPage = () => {
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <View style={styles.container}>
      {/* App Logo */}
      <View style={styles.logoContainer}>
        <Image
          source={require("../../assets/logo.png")}
          style={styles.logo}
        />
      </View>

      {/* Image Section from RegistrationPage */}
      <View style={styles.imageContainer}>
        <Image
          source={require("../../assets/huxedo-landing-page.png")}
          style={styles.image}
        />
      </View>

      {/* Title */}
      <Text style={styles.title}>Welcome to Huxedo!</Text>
      <Text style={styles.downloadText}>Your AI assistant for home management</Text>

      {/* Single Button for QR Code */}
      <TouchableOpacity
        style={styles.qrButton}
        onPress={() => setModalVisible(true)}
      >
        <Text style={styles.qrButtonText}>Download App</Text>
      </TouchableOpacity>

      {/* QR Code Modal */}
      <Modal
        animationType="slide"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => setModalVisible(false)}
      >
        <View style={styles.modalContainer}>
          <View style={styles.modalContent}>
            <Text style={styles.modalTitle}>Download App</Text>
            <QRCode
              value="https://expo.dev/preview/update?message=Updated%20Google%20maps%20api%20and%20updated%20the%20keyboard%20overlay&updateRuntimeVersion=0.0.2&createdAt=2024-11-30T09%3A48%3A49.052Z&slug=exp&projectId=2e54e136-fba0-4532-95b7-d47716a86849&group=3d30581a-45e4-4ed5-9cf9-9dbace57ae94"
              size={200}
              logo={require("../../assets/logo.png")}
              logoSize={50}
              logoBackgroundColor="transparent"
            />
            <Text style={styles.modalText}>Scan the QR Code on your phone to download the app</Text>
            <TouchableOpacity
              style={styles.closeButton}
              onPress={() => setModalVisible(false)}
            >
              <Text style={styles.closeButtonText}>Close</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    alignItems: "center",
    justifyContent: "flex-start",
    backgroundColor: "#000",
  },
  logoContainer: {
    alignSelf: "flex-start",
    marginBottom: 20,
  },
  logo: {
    width: 50,
    height: 50,
  },
  imageContainer: {
    width: "60%",
    height: "60%",
    alignItems: "center",
    justifyContent: "center",
  },
  image: {
    width: "100%",
    height: "100%",
    resizeMode: "cover",
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    margin: 20,
    textAlign: "center",
    color: "#fff",
  },
  downloadText: {
    fontSize: 16,
    marginBottom: 15,
    color: "#fff",
  },
  qrButton: {
    marginTop: 20,
    backgroundColor: "#007BFF",
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 5,
  },
  qrButtonText: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "bold",
  },
  modalContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
  },
  modalContent: {
    backgroundColor: "#fff",
    padding: 20,
    borderRadius: 10,
    alignItems: "center",
  },
  modalTitle: {
    fontSize: 20,
    fontWeight: "bold",
    marginBottom: 20,
  },
  modalText: {
    marginTop: 20,
    fontSize: 16,
    textAlign: "center",
  },
  closeButton: {
    marginTop: 20,
    backgroundColor: "#007BFF",
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 5,
  },
  closeButtonText: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "bold",
  },
});

export default WebPage;
